import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import EditOrderForm from "../EditOrderForm";
import { TApiOrderDetails } from "../../../api/endpoints/Order";
import IconButton from "../../../components/Buttons/IconButton";
import { faEdit } from "@fortawesome/free-regular-svg-icons";

interface IProps {
  order: TApiOrderDetails;
  onSuccess?: (order: TApiOrderDetails) => void;
  disabled?: boolean;
}

const EditOrderButton = (props: IProps) => {
  const { order, onSuccess, disabled } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleClick = () => {
    setShow(true);
  }

  const onSubmit = (order: TApiOrderDetails) => {
    handleClose();
    onSuccess && onSuccess(order);
  }

  return (
    <Fragment>
      <IconButton icon={faEdit} variant="primary" onClick={handleClick} disabled={disabled} title="Edit order" />

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditOrderForm order={order} onSubmit={onSubmit} />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default EditOrderButton;
